module.exports = __webpack_public_path__ + "img/3c.ad447746.png";